"use client";

import { Stub } from "@/composites/_internal";

/**
 * STUB — replaced in a subsequent ticket. See `docs/PDP_ARCHITECTURE.md`
 *
 * Intent: Wraps DS CardCarousel + ProductCard. Used by recipe-pairings, paired-products, cross-sells blocks.
 */
export function ProductCardCarousel() {
	return (
		<Stub
			name="product/ProductCardCarousel"
			intent="Wraps DS CardCarousel + ProductCard. Used by recipe-pairings, paired-products, cross-sells blocks."
		/>
	);
}
